import * as R from 'ramda';
import { ActionType } from '../../../core/redux/actionType';
import { makeApiAction, makeRsaaTypes, ApiReducer, makeApiReducer } from '../../../core/api/rsaa';
import { Endpoints } from '../../../core/api/endpoints';
import { getLoading, addLoading, addError, noLoadingNoError } from '../../../core/api/module';
import { EmailBody } from './models';


const KEY_ACTION = ActionType.ApproverEmailPreviewRequest;
const ACTIONS    = [
  ActionType.ApproverEmailPreviewRequest,
  ActionType.ApproverEmailPreviewResponse,
  ActionType.ApproverEmailPreviewError,
];


type Payload = EmailBody;


type Meta = {
  projectId: number;
  languageId: number;
};


/**
 * Dispatch this action to send invitation emails to all as-yet uninvited raters who have been added to the given
 * project for the listed participant
 */
export const approverEmailPreviewAction = (
    projectId: number,
    languageId: number,
    emailAddress: string,
  ) => makeApiAction<Payload, Meta>(
  {
    method:   'POST',
    endpoint: Endpoints.ApproverEmailPreview,
    headers:  { 'content-type': 'application/json' },
    body:     JSON.stringify({
      projectId:  projectId,
      languageId: languageId,
      emailAddress: emailAddress,
    }),
    types:    makeRsaaTypes<Payload, Meta>(ACTIONS, { projectId, languageId }),
    bailout:  state => !!getLoading(state, KEY_ACTION, `${projectId}-${languageId}`),
  },
);

const reducer: ApiReducer<Payload, Meta> = (state, action, errorMsg, isLoading, payload) => {
  const metaTag = `${action.meta.projectId}-${action.meta.languageId}`;

  if (isLoading) {
    return addLoading(state, KEY_ACTION, metaTag);
  }

  if (errorMsg) {
    return addError(state, KEY_ACTION, errorMsg, metaTag);
  }

  const successState = noLoadingNoError(state, KEY_ACTION, metaTag);

  return R.assocPath(
    ['approverEmailTemplates', `${state.projectSummary?.projectId}` || '0', `${state.locale.lang.languageId}`],
    payload,
    successState,
  );
};

export const approverEmailPreviewReducer = makeApiReducer<Payload, Meta>(ACTIONS, KEY_ACTION, reducer);
